let observingController = false
let registrationPromise: Promise<ServiceWorkerRegistration | null> | undefined

export function registerServiceWorker(): Promise<ServiceWorkerRegistration | null> {
  if (!import.meta.env.PROD || !('serviceWorker' in navigator)) return Promise.resolve(null)
  if (registrationPromise) return registrationPromise

  if (!observingController) {
    observingController = true
    let hasController = Boolean(navigator.serviceWorker.controller)
    let reloading = false
    navigator.serviceWorker.addEventListener('controllerchange', () => {
      // Ignore the initial claim, but allow later updates in this same first session.
      if (!hasController) { hasController = true; return }
      if (reloading) return
      reloading = true
      window.location.reload()
    })
  }

  registrationPromise = navigator.serviceWorker
    .register('/sw.js', { scope: '/', updateViaCache: 'none' })
    .then(registration => {
      const update = () => { void registration.update().catch(error => console.error('Service worker update failed:', error)) }
      document.addEventListener('visibilitychange', () => {
        if (document.visibilityState === 'visible') update()
      })
      return registration
    })
    .catch(error => {
      console.error('Service worker registration failed:', error)
      registrationPromise = undefined
      return null
    })
  return registrationPromise
}
